export default {
    posts: state => state.posts,
    categories: state => state.categories,
    currentPost: state => state.currentPost,
    currentCategory: state => state.currentCategory
};



//////////////////
// WEBPACK FOOTER
// ./src/store/getters.ts
// module id = null
// module chunks = 